import ShSideMenu from '@/components/common/sideMenu/ShSideMenu.vue'
import MSH_SR_001 from '@/views/sh/MSH_SR_001.vue'
import MSH_SR_002 from '@/views/sh/MSH_SR_002.vue'
import MSH_SR_003 from '@/views/sh/MSH_SR_003.vue'
import MSH_SR_004 from '@/views/sh/MSH_SR_004.vue'

const managerRouter = [
    /* 화면명 : 담당자 등록  : MSH_SR_001  */
    {
        path: "/sh/MSH_SR_001", 
        name : 'MSH_SR_001',
        components: {
            default : MSH_SR_001,
            sideMenu : ShSideMenu
        },
        meta :{
            title: '담당자 등록',
            IADepth: ['담당자', '담당자 등록관리', '담당자 등록/수정']
        }
    },

    /* 화면명 : 담당자 조회 : MSH_SR_002 */
    {
        path: "/sh/MSH_SR_002", 
        name : 'MSH_SR_002',
        components: {
            default : MSH_SR_002,
            sideMenu : ShSideMenu
        },
        meta :{
            title: '담당자 조회',
            IADepth: ['담당자', '담당자 등록관리', '담당자 조회']
        }
    },

    /* 화면명 : 담당자 수정 : MSH_SR_003 */
    {
        path: "/sh/MSH_SR_003", 
        name : 'MSH_SR_003',
        components: {
            default : MSH_SR_003,
            sideMenu : ShSideMenu
        },
        meta :{
            title: '담당자 수정',
            IADepth: ['담당자', '담당자 등록관리', '담당자 등록/수정']
        }
    },

    /* 화면명 : 담당자 상세조회 : MSH_SR_004 */
    {
        path: "/sh/MSH_SR_004", 
        name : 'MSH_SR_004',
        components: {
            default : MSH_SR_004,
            sideMenu : ShSideMenu
        },
        meta :{
            title: '담당자 상세조회',
            IADepth: ['담당자', '담당자 등록관리', '담당자 상세조회']
        }
    },

]
export {managerRouter}